import classNames from 'classnames'

import { LinkType } from 'types'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import Paragraph from 'content-components/_Primatives/Paragraph'
import Button from 'content-components/_Primatives/Button'
import useSticky from './useSticky'
import style from './style.scss'

export type Props = {
  headlineText: string
  bodyText: string
  link: LinkType
  secondaryLink?: LinkType
}

function StickyCTA({ headlineText, bodyText, link, secondaryLink }: Props) {
  const { stickyRef, isSticky } = useSticky<HTMLDivElement>(-12)

  return (
    <div className={classNames(style.wrapper, { [style.sticky]: isSticky })}>
      <div
        className={classNames(style.content, { [style.sticky]: isSticky })}
        ref={stickyRef}
      >
        <HeadlineTwo className={style.headlineText}>{headlineText}</HeadlineTwo>
        <Paragraph className={style.bodyText}>{bodyText}</Paragraph>

        <div className={style.buttons}>
          <Button className={style.button} url={link.url} variant='primaryBlue'>
            {link.text}
          </Button>

          {secondaryLink && (
            <Button
              className={style.button}
              url={secondaryLink.url}
              variant='primaryBlue'
            >
              {secondaryLink.text}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default StickyCTA
